// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"28": "61c84edf","366": "9154912f","606": "c84d2253","985": "482cb750",}[chunkId] + ".css"
}